export default class Socket{
    #buscador;
    #options;
    #interval
    constructor() {
        this.#buscador = new URLSearchParams(window.location.search)
    }

    /**
     * Determina utilizando #options si el procesador consultado es un link de pago
     * @return el valor de #options en la posicion [1][1]
     */
    isLink(){
        return this.#options[1][1].localeCompare("true") === 0
    }

    checkAmountType(){
        if (this.#options[4][1].localeCompare("true") == 0){
            if (this.#buscador.get("amount") != null){
                document.querySelector(".information-container .amount-container").remove()
                var value = Number(this.#buscador.get("amount"))
                document.querySelector(".form-container .amount-container h2").setAttribute("amount",value)
                if (this.datas.currency == 1){

                    document.querySelector(".form-container .amount-container h2").textContent = this.mxnFormat(value)
                }else{
                    document.querySelector(".form-container .amount-container h2").textContent = this.usdFormat(value)
                }
            }
        }
    }

    checkEnablePhone(){
        if (this.#options[6][1].localeCompare("true") == 0){
            document.querySelector(".phone").remove()
        }
    }

    mxnFormat(data){
        return Intl.NumberFormat('es-MX',{style:'currency',currency:'MXN'}).format(data) + " MXN"
    }

    usdFormat(data){
        return Intl.NumberFormat('es-MX',{style:'currency',currency:'USD'}).format(data)
    }

    /**
     * Obtiene los datos del nuevo formulario y configura el campo de telefono en caso de ser requerido.
     * @param id {Number} es el identificador del campo link que vamos a crear
     */
    async getInformation( ){
        var formData = new FormData();
        formData.append("id", this.#buscador.get("id"))

        var data = await fetch("https://processor.savethechildrenmx.org/getProcessorDatas.php",{
            method: 'POST',
            body: formData
        }).then(resp=>{
            if (resp.status ==200){
                return resp.text();
            }
        })

        localStorage.setItem("options",data);

        var datas = JSON.parse(data);
        this.datas = datas;

        var options =datas.inputs_json.split("}")
        document.querySelector(".desc h2").textContent = datas.description

        options.forEach((element,index)=>{
            var aux = element.split(":")
            if (aux.length === 3){
                aux[1] = aux[1].split(",")
                aux = [aux[1][0],aux[2]]
                options[index] = aux
            }
        })

        this.#options=options

        if(this.datas.currency == 2){
            this.translate();
        }

        if (this.isLink()){
            this.checkAmountType()
            this.checkEnablePhone()
        }else{
            alert("esta url no pertenece a un link valido, por favor verifica el link y vuelve a intentarlo")
            window.location.reload()
        }
    }

    translate(){
        document.querySelector(".item-1").textContent="Make donation to:"
        document.querySelector(".item-2").textContent="For: "
        document.querySelector(".item-3").textContent="Amount:"
        if (document.querySelector(".item-4 label")){
            document.querySelector(".item-4 label").textContent= "Enter your donation's amount: "
        }
        document.querySelector(".item-5 label").textContent= "First name: "
        document.querySelector(".item-6 label").textContent= "Last name: "
        document.querySelector(".item-7 label").textContent= "Email: "
        document.querySelector(".item-8 label").textContent= "Phone: "
        document.querySelector(".item-10 .text-1").textContent="Add payment fees to my donatinon:  "
        document.querySelector(".item-10 .text-2").textContent=""
        document.querySelector(".item-11 button").textContent="Continue "
        document.querySelector(".item-12 label").textContent="Cardholder Name "
        document.querySelector(".item-13 label").textContent="Card Number "
        document.querySelector(".item-14 label").textContent="Expiry Month"
        document.querySelector(".item-15 label").textContent="Expiry Year"
        document.querySelector(".item-17 button").textContent="Pay and Finish"
        document.querySelector(".item-18").textContent="Loading"
    }

    async check3dSecure(){
        var result= JSON.parse(localStorage.getItem("result"));
        var formData = new FormData()
        formData.append("pi",result.payment_intent)
        formData.append("contact",result.contact)
        formData.append("deal",result.deal)
        formData.append("options", localStorage.getItem("options"))

        var data = await fetch("https://processor.savethechildrenmx.org/check3d.php",{
            method: "POST",
            body: formData
        }).then(resp=>{
            return resp.text();
        })

        if (Number(data) === 200){
            document.querySelector(".alert-container").classList.add("hide")
            document.querySelector(".facturacion-container").classList.remove("hide")
            fetch("https://api.savethechildrenmx.org/events_api/getRegimen.php",{
                method:'POST',
                body:''
            }).then(resp=>{
                return resp.text()
            }).then(txt=>{
                var data = JSON.parse(txt);
                data.forEach(element=>{
                    var option = document.createElement("option")

                    option.value = element.nombre
                    option.text = element.nombre

                    document.getElementById("36").appendChild(option)
                })

                document.getElementById("36").parentElement.classList.add("is-valid")
            })
        }else{
            if (data==500){
                localStorage.clear();
                window.location.href = "https://processor.savethechildrenmx.org/error-pago"
            }
        }
    }


    async sendPay(){
        document.querySelector(".alert-container").classList.remove("hide")
        var formData = new FormData();

        document.querySelectorAll("input").forEach(element=>{
            formData.append(element.id,element.value)
        })

        formData.append("amount",document.querySelector(".form-container .amount-container h2").getAttribute("amount"))
        formData.append("options", localStorage.getItem("options"))

        if (this.#buscador.get("utm_campaign")!=null){
            formData.append("71",this.#buscador.get("utm_campaign"));
        }
        if (this.#buscador.get("utm_source")!=null){
            formData.append("72",this.#buscador.get("utm_source"));
        }
        if (this.#buscador.get("utm_content")!=null){
            formData.append("74",this.#buscador.get("utm_content"));
        }
        if (this.#buscador.get("utm_medium")!=null){
            formData.append("73",this.#buscador.get("utm_medium"));
        }
        if (this.#buscador.get("utm_term")!=null){
            formData.append("101",this.#buscador.get("utm_term"));
        }
        if (this.#buscador.get("ch")!=null){
            formData.append("29",this.#buscador.get("ch"));
        }

        if (this.#buscador.get("tickets")!= null){
            formData.append("tickets",document.getElementById("boletos").value)
        }


        var result = localStorage.getItem("result");
        if (result != null && result.length > 0){
            result = JSON.parse(result)
            formData.append("deal",result.deal);
        }
        var response = await fetch("https://processor.savethechildrenmx.org/saveDatas.php",{
            method:"POST",
            body: formData
        }).then(resp=>{
            return resp.text()
        });

        localStorage.setItem("result",response);

        var data = JSON.parse(response)

        if (data.status == 200){

            if (this.isEng()){
                window.location.href="https://apoyo.savethechildren.mx/invoice"
            }else{
                document.querySelector(".information-container").classList.add("d-none")
                document.querySelector(".bank-information").classList.add("d-none")
                document.querySelector(".facturacion-container").classList.remove("hide")
                fetch("https://api.savethechildrenmx.org/events_api/getRegimen.php",{
                    method:'POST',
                    body:''
                }).then(resp=>{
                    return resp.text()
                }).then(txt=>{
                    var data = JSON.parse(txt);
                    data.forEach(element=>{
                        var option = document.createElement("option")

                        option.value = element.nombre
                        option.text = element.nombre

                        document.getElementById("36").appendChild(option)
                    })

                    document.getElementById("36").parentElement.classList.add("is-valid")
                })
            }
        }else{
            if (data.status == 100){
                this.#interval = setInterval(this.check3dSecure,5000)
                window.open(data.redirect_to,"3d secure")
            }else {
                localStorage.clear()
                window.location.href = "https://apoyo.savethechildren.mx/error-pago"
            }
        }
    }

    format(data){
        console.log(this.datas)
        if (this.datas.currency == 1){
            return this.mxnFormat(data)
        }else{
            return this.usdFormat(data)
        }
    }

    isEng(){
        return JSON.parse(localStorage.getItem("options")).currency==2;
    }

}